import { useHead } from '@unhead/react';
import { useState } from 'react';
import { useTranslation } from 'translations/hooks';

import { SteeringFilters } from 'business/steering/components/steering-filters';
import { SteeringPageTemplate } from 'business/steering/components/steering-page-template';
import { SteeringChartModal } from 'business/steering/pages/table-page/components/chart/steering-chart-modal';
import { SteeringTableHeader } from 'business/steering/pages/table-page/components/steering-table-header';
import { SteeringFiltersProvider } from 'business/steering/providers/steering-filters-provider';
import { useFilterData } from 'technical/filter-data';
import { useMediaType } from 'technical/media/hooks';
import { CustomFilterCard } from 'ui/filter-card';
import { SelectedItemsFooter } from 'ui/filter-footer';
import { DateSelectionTypeEnum } from 'ui/form/temporality-select-input';

import { SteeringTableWithPagination } from './components/steering-table-with-pagination';
import { MobileSteeringTable } from './mobile';

export interface SteeringTableFilterData {
  selectedRings?: number;
}

const SteeringTablePage = () => {
  const { t } = useTranslation();
  const { isMobile } = useMediaType();

  const { filterData, setFilterData } =
    useFilterData<SteeringTableFilterData>();

  useHead({ title: t('user.menu.sections.steering.table.title') });

  const [steeringModalOpen, setSteeringModalOpen] = useState(false);

  if (isMobile) {
    return <MobileSteeringTable />;
  }

  return (
    <SteeringFiltersProvider
      initialFilters={{
        filterType: 'date',
        dateRange: [null, null],
      }}
      noDefaultFor={[DateSelectionTypeEnum.Period]}
    >
      <SteeringPageTemplate
        title={t('steering.table.title')}
        filters={
          <CustomFilterCard
            footer={
              filterData?.selectedRings ? (
                <SelectedItemsFooter>
                  {t('steering.filters.selectedRings', {
                    selectedRings: filterData.selectedRings,
                  })}
                </SelectedItemsFooter>
              ) : null
            }
          >
            <SteeringFilters noDefaultFor={[DateSelectionTypeEnum.Period]} />
          </CustomFilterCard>
        }
        header={
          <SteeringTableHeader openModal={() => setSteeringModalOpen(true)} />
        }
      >
        <SteeringTableWithPagination setFilterData={setFilterData} />
        <SteeringChartModal
          visibleModal={steeringModalOpen}
          closeModal={() => setSteeringModalOpen(false)}
          filterData={filterData}
        />
      </SteeringPageTemplate>
    </SteeringFiltersProvider>
  );
};

export default SteeringTablePage;
